import ToolStylus from './ToolStylus';
import Shortcut from '../utils/Shortcut';

class ToolStylusStamp extends ToolStylus {
  static toolName = 'Stamp emoji';
  static shortcut = new Shortcut('E');

  static action({ controller }) {
    controller.actionSetStylus(controller.stylusStamp);
  }
}

export default ToolStylusStamp;
